import { Main } from '@cotera/client/app/components/ui/main';
import { ErrorView } from '@cotera/client/app/components/app/error/error-view';

export const Fallback: React.FC = () => (
  <Main>
    <ErrorView />
  </Main>
);
